import { Box } from '../Box/Box';
import { Card } from '../Card/Card';
import { Skeleton } from '../Skeleton/Skeleton';
import { Stack } from '../Stack/Stack';

export function LoadingReportCard() {
  return (
    <Card variant="outlined">
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
      >
        <Box width={{ xs: '100%', md: '60%' }}>
          <Skeleton
            variant="rounded"
            width={121}
            height={29}
            sx={{ mb: 1 }}
            role="status"
          />
          <Skeleton
            variant="rounded"
            width={121}
            height={17}
            sx={{ mb: 2.5 }}
            role="status"
          />
          <Skeleton
            variant="rounded"
            sx={{ width: { xs: '100%', md: 245 }, mb: { xs: 2.5, md: 0 } }}
            height={17}
            role="status"
          />
        </Box>
        <Box width={{ xs: '100%', md: '40%' }}>
          <Stack direction="row" justifyContent="flex-end">
            <Skeleton
              variant="rounded"
              height={40}
              sx={{ width: { xs: '100%', md: 172 }, mb: 3 }}
              role="status"
            />
          </Stack>
          <Stack
            direction="row"
            justifyContent={{ xs: 'space-between', md: 'flex-end' }}
            spacing={1.5}
          >
            <Skeleton variant="rounded" width={78} height={21} role="status" />
            <Skeleton variant="rounded" width={78} height={21} role="status" />
            <Skeleton variant="rounded" width={78} height={21} role="status" />
            <Skeleton variant="rounded" width={78} height={21} role="status" />
          </Stack>
        </Box>
      </Stack>
    </Card>
  );
}
